export default __webpack_public_path__ + "static/media/Anuphan-Regular.8b1f7396.woff2";